<template>
  <loader content="Please wait" visible="true" />
  <!-- <div class="container" style="padding-top: 75px;">
    <div class="col md-6">
      <div class="temp-notify">
        This page is still on-progress.
      </div>
    </div>
    <div class="row text-center">
      <div class="image-failed"></div>
      <div class="col-md-8 col-md-offset-2 text-center">
        <h3>Your transaction failed !</h3>
        <p class="text-center mb-20">
          All transaction failed stored in <b>My Booking</b> menu, you can retry or change
          your payment method easily.
        </p>
        <div class="button-group">
          <a href="" class="btn btn-default"> Detail Transaction </a>
          <a href="" class="btn btn-primary"> Close </a>
        </div>
      </div>
      <div class="col-md-6 col-md-offset-3">
        <div class="total-info">
          <h4>Total Bayar</h4>
          <div class="value-box">2.000.000<span class="currency">IDR</span></div>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
export default {
  created() {
    const reservationId = this.$route.query.reservation_id;
    if (reservationId) { this.$router.push({ path: `/reservation/inquiry/${reservationId}` }); }
    else { this.$router.push({ path: '/404' }); }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/payment/credit/back.vue